(function() {
  'use strict';

  var FILTER_GROUPS = [
    { label: 'Recipient', items: [
      { text: 'For Her', tag: 'recipient-her' },
      { text: 'For Him', tag: 'recipient-him' },
      { text: 'For the Home', tag: 'recipient-home' },
      { text: 'For Couples', tag: 'recipient-couple' }
    ]},
    { label: 'Occasion', items: [
      { text: 'Birthday', tag: 'occasion-birthday' },
      { text: 'Wedding', tag: 'occasion-wedding' },
      { text: 'Anniversary', tag: 'occasion-anniversary' },
      { text: 'Festival', tag: 'occasion-festival' },
      { text: 'Graduation', tag: 'occasion-graduation' },
      { text: 'Housewarming', tag: 'occasion-housewarming' }
    ]},
    { label: 'Category', items: [
      { text: 'Photo Frames', tag: 'type-photo-frame' },
      { text: 'Candle Holders', tag: 'type-candle' },
      { text: 'Homeware', tag: 'type-homeware' },
      { text: 'Jewellery', tag: 'type-jewellery' },
      { text: 'Kitchenware', tag: 'type-kitchenware' }
    ]}
  ];

  var selectedTags = new Set();
  var tagMap = {};
  var isDesktop = window.innerWidth >= 990;

  function readHashTags() {
    var m = window.location.hash.match(/alo-tags=([^&]*)/);
    return m && m[1] ? m[1].split(',').filter(Boolean) : [];
  }
  function writeHashTags() {
    var base = window.location.hash.replace(/#?alo-tags=[^&]*/g, '').replace(/^#/, '').replace(/^&|&$/, '');
    var tagsStr = Array.from(selectedTags).join(',');
    var newHash = (base ? base + '&' : '') + (tagsStr ? 'alo-tags=' + tagsStr : '');
    history.replaceState(null, '', window.location.pathname + window.location.search + (newHash ? '#' + newHash : ''));
  }
  readHashTags().forEach(function(t) { selectedTags.add(t); });

  function getCollectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : 'all-products';
  }
  function fetchAllProductTags() {
    return new Promise(function(resolve) {
      var handle = getCollectionHandle();
      var page = 1;
      function fetchPage() {
        fetch('/collections/' + handle + '/products.json?limit=250&fields=handle,tags&page=' + page)
          .then(function(r) { return r.json(); })
          .then(function(d) {
            if (!d.products || d.products.length === 0) { resolve(); return; }
            d.products.forEach(function(p) { tagMap[p.handle] = p.tags || []; });
            if (d.products.length < 250) { resolve(); return; }
            page++; fetchPage();
          });
      }
      fetchPage();
    });
  }

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.href.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }
  function tagCards() {
    document.querySelectorAll('li.grid__item:not([data-alo-tagged])').forEach(function(card) {
      var handle = getHandle(card);
      if (handle) card.setAttribute('data-tags', (tagMap[handle] || []).join(','));
      var btn = card.querySelector('button[type="submit"]');
      card.setAttribute('data-oos', (btn && btn.disabled) ? '1' : '0');
      card.setAttribute('data-alo-tagged', '1');
    });
  }

  function sortOOSToBottom() {
    var grid = document.querySelector('ul.product-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('li.grid__item'));
    cards.forEach(function(c) { c.style.order = c.getAttribute('data-oos') === '1' ? '1' : '0'; });
  }

  function applyFilters() {
    var grid = document.querySelector('ul.product-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('li.grid__item');
    var visible = 0;
    cards.forEach(function(card) {
      var cardTags = (card.getAttribute('data-tags') || '').split(',');
      var show = true;
      selectedTags.forEach(function(tag) {
        if (cardTags.indexOf(tag) === -1) show = false;
      });
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    document.querySelectorAll('.alo-sort-bar__count').forEach(function(el) {
      el.textContent = visible + (visible === 1 ? ' product' : ' products');
    });
  }
  function updateActiveUI() {
    document.querySelectorAll('.alo-custom-filter-btn').forEach(function(btn) {
      btn.classList.toggle('alo-active', selectedTags.has(btn.getAttribute('data-tag')));
    });
    document.querySelectorAll('.alo-active-filters, .alo-mobile-active-filters').forEach(function(el) {
      el.style.display = selectedTags.size > 0 ? '' : 'none';
    });
  }
  function onFilterBtnClick() {
    var t = this.getAttribute('data-tag');
    selectedTags.has(t) ? selectedTags.delete(t) : selectedTags.add(t);
    writeHashTags(); updateActiveUI(); applyFilters();
  }

  function chevronSVG() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 10 6'); svg.setAttribute('class', 'alo-chevron'); svg.setAttribute('fill', 'none');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M1 1l4 4 4-4'); path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5'); path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path); return svg;
  }

  function makeFilterGroup(group, isMobile) {
    var details = document.createElement('details');
    details.className = isMobile
      ? 'mobile-facets__details alo-mobile-filter-group'
      : 'alo-custom-filter-group';
    if (!isMobile) details.setAttribute('open', '');
    var summary = document.createElement('summary');
    if (isMobile) {
      summary.className = 'mobile-facets__summary focus-inset';
      var nameDiv = document.createElement('div');
      nameDiv.innerHTML = '<span>' + group.label + '</span>' +
        '<span class="mobile-facets__arrow no-js-hidden">' +
        '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/>' +
        '</svg></span>';
      summary.appendChild(nameDiv);
    } else {
      summary.appendChild(document.createTextNode(group.label));
      summary.appendChild(chevronSVG());
    }
    details.appendChild(summary);
    var ul = document.createElement('ul');
    ul.className = isMobile ? 'mobile-facets__list no-js-hidden' : 'alo-custom-filter-links';
    group.items.forEach(function(item) {
      var li = document.createElement('li');
      li.className = isMobile ? 'mobile-facets__item' : '';
      var btn = document.createElement('button');
      btn.className = (isMobile ? 'alo-custom-filter-btn mobile-facets__label' : 'alo-custom-filter-btn') + (selectedTags.has(item.tag) ? ' alo-active' : '');
      btn.setAttribute('data-tag', item.tag);
      btn.textContent = item.text;
      btn.addEventListener('click', onFilterBtnClick);
      li.appendChild(btn); ul.appendChild(li);
    });
    details.appendChild(ul);
    return details;
  }

  // ─── DESKTOP SIDEBAR ──────────────────────────────────────────────────────
  function buildDesktopSidebar() {
    var filterSidebar = document.getElementById('main-collection-filters');
    if (!filterSidebar) return;

    var label = document.createElement('span');
    label.className = 'alo-filter-label';
    label.textContent = 'Filter';
    var facetsCont = filterSidebar.querySelector('.facets-container');
    if (facetsCont) filterSidebar.insertBefore(label, facetsCont);
    else filterSidebar.prepend(label);

    // Retry opening native facet details every 250ms for 2s
    var attempts = 0;
    var timer = setInterval(function() {
      document.querySelectorAll('#FacetsWrapperDesktop details:not([open])').forEach(function(d) {
        d.setAttribute('open', '');
      });
      if (++attempts >= 8) clearInterval(timer);
    }, 250);

    var sortSelect = filterSidebar.querySelector('select[name="sort_by"]');
    var countEl = filterSidebar.querySelector('.product-count');
    var collection = document.querySelector('.collection.page-width');
    if (sortSelect && collection) {
      var bar = document.createElement('div');
      bar.className = 'alo-sort-bar';
      var countSpan = document.createElement('span');
      countSpan.className = 'alo-sort-bar__count';
      countSpan.textContent = countEl ? countEl.textContent.trim() : '';
      bar.appendChild(countSpan);
      var lbl = document.createElement('span');
      lbl.className = 'alo-sort-bar__label';
      lbl.textContent = 'Sort by:';
      bar.appendChild(lbl);
      var newSelect = document.createElement('select');
      newSelect.className = 'alo-sort-bar__select';
      Array.from(sortSelect.options).forEach(function(opt) {
        var o = document.createElement('option');
        o.value = opt.value; o.textContent = opt.textContent; o.selected = opt.selected;
        newSelect.appendChild(o);
      });
      newSelect.addEventListener('change', function() {
        var params = new URLSearchParams(window.location.search);
        this.value ? params.set('sort_by', this.value) : params.delete('sort_by');
        params.delete('page');
        var qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      });
      bar.appendChild(newSelect);
      collection.insertBefore(bar, collection.firstChild);
    }

    var customWrap = document.createElement('div');
    customWrap.className = 'alo-custom-filters';

    var clearBar = document.createElement('div');
    clearBar.className = 'alo-active-filters';
    clearBar.style.display = selectedTags.size > 0 ? '' : 'none';
    var clearBtn = document.createElement('button');
    clearBtn.className = 'alo-clear-filters';
    clearBtn.textContent = 'Clear filters';
    clearBtn.addEventListener('click', function() {
      selectedTags.clear(); writeHashTags(); updateActiveUI(); applyFilters();
    });
    clearBar.appendChild(clearBtn);
    customWrap.appendChild(clearBar);

    FILTER_GROUPS.forEach(function(group) {
      customWrap.appendChild(makeFilterGroup(group, false));
    });

    var facetsForm = filterSidebar.querySelector('#FacetFiltersForm');
    if (facetsForm) facetsForm.parentElement.insertBefore(customWrap, facetsForm.nextSibling);
    else filterSidebar.appendChild(customWrap);
  }

  // ─── MOBILE FILTER INJECTION ──────────────────────────────────────────────
  function buildMobileFilters() {
    var mobileMain = document.querySelector('#FacetFiltersFormMobile .mobile-facets__main');
    if (!mobileMain || mobileMain.querySelector('.alo-mobile-custom-filters')) return;

    var wrap = document.createElement('div');
    wrap.className = 'alo-mobile-custom-filters';

    var clearBar = document.createElement('div');
    clearBar.className = 'alo-mobile-active-filters';
    clearBar.style.display = selectedTags.size > 0 ? '' : 'none';
    var clearBtn = document.createElement('button');
    clearBtn.className = 'alo-mobile-clear-filters';
    clearBtn.textContent = 'Clear custom filters';
    clearBtn.addEventListener('click', function() {
      selectedTags.clear(); writeHashTags(); updateActiveUI(); applyFilters();
    });
    clearBar.appendChild(clearBtn);
    wrap.appendChild(clearBar);

    FILTER_GROUPS.forEach(function(group) {
      wrap.appendChild(makeFilterGroup(group, true));
    });

    // Find the footer that is a direct child of mobileMain (not nested inside a submenu)
    var mobileFooter = null;
    Array.from(mobileMain.children).forEach(function(child) {
      if (child.classList.contains('mobile-facets__footer')) mobileFooter = child;
    });
    if (mobileFooter) { mobileMain.insertBefore(wrap, mobileFooter); }
    else { mobileMain.appendChild(wrap); }
  }

  // ─── INFINITE SCROLL HOOK ─────────────────────────────────────────────────
  function hookInfiniteScroll() {
    var grid = document.querySelector('ul.product-grid');
    if (!grid) return;
    new MutationObserver(function(mutations) {
      var added = false;
      mutations.forEach(function(m) { if (m.addedNodes.length) added = true; });
      if (!added) return;
      setTimeout(function() {
        tagCards(); sortOOSToBottom();
        if (selectedTags.size > 0) applyFilters();
      }, 150);
    }).observe(grid, { childList: true });
  }

  // ─── MAIN ─────────────────────────────────────────────────────────────────
  if (isDesktop) {
    buildDesktopSidebar();
    // Dynamically size sidebar to viewport minus sticky header
    function setSidebarMaxHeight() {
      var sidebar = document.getElementById('main-collection-filters');
      if (!sidebar) return;
      var stickyHeader = document.querySelector('sticky-header, .header-wrapper, header.header');
      var headerH = stickyHeader ? stickyHeader.offsetHeight : 100;
      var announcementBar = document.querySelector('.announcement-bar__wrap, [id*="announcement"] .announcement-bar');
      var announcementH = announcementBar ? announcementBar.offsetHeight : 0;
      sidebar.style.maxHeight = (window.innerHeight - headerH - announcementH - 16) + 'px';
    }
    setSidebarMaxHeight();
    window.addEventListener('resize', setSidebarMaxHeight);
  }
  // Set CSS variable for mobile drawer offset (accounts for sticky header height)
  function setMobileDrawerOffset() {
    var stickyHeader = document.querySelector('sticky-header');
    var h = stickyHeader ? stickyHeader.offsetHeight : 0;
    document.documentElement.style.setProperty('--alo-mobile-top', h + 'px');
  }
  setMobileDrawerOffset();
  window.addEventListener('resize', setMobileDrawerOffset);

  buildMobileFilters();

  fetchAllProductTags().then(function() {
    tagCards();
    sortOOSToBottom();
    hookInfiniteScroll();
    if (selectedTags.size > 0) applyFilters();
  });

})();

/* View button — mousedown beats Snap Cart's capture click handler; touchend with swipe guard handles slider */
(function() {
  document.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return;
    var btn = e.target && e.target.closest ? e.target.closest('.alr-view-btn') : null;
    if (!btn) return;
    var href = btn.getAttribute('href') || '';
    if (!href) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    window.location.href = href;
  }, { capture: true });

  var _alrTouchX = 0, _alrTouchY = 0;
  document.addEventListener('touchstart', function(e) {
    if (e.touches[0]) { _alrTouchX = e.touches[0].clientX; _alrTouchY = e.touches[0].clientY; }
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.alr-view-btn') : null;
    if (!btn) return;
    if (!e.changedTouches[0]) return;
    var dx = Math.abs(e.changedTouches[0].clientX - _alrTouchX);
    var dy = Math.abs(e.changedTouches[0].clientY - _alrTouchY);
    if (dx > 8 || dy > 8) return;
    var href = btn.getAttribute('href') || '';
    if (!href) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    window.location.href = href;
  }, { capture: true });
})();


/* Push sold-out products to end of grid */
(function() {
  var _observer = null;
  var _sorting = false;

  function sortSoldOutToBottom() {
    if (_sorting) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    var inStock = [], soldOut = [];
    items.forEach(function(item) {
      if (item.querySelector('.price--sold-out')) {
        soldOut.push(item);
      } else {
        inStock.push(item);
      }
    });
    if (!soldOut.length) return;
    var _correct = inStock.concat(soldOut);
    if (_correct.every(function(v,i){return v===items[i];})) return;
    _sorting = true;
    if (_observer) _observer.disconnect();
    inStock.concat(soldOut).forEach(function(item) { grid.appendChild(item); });
    if (_observer) _observer.observe(grid, { childList: true });
    _sorting = false;
  }

  function init() {
    sortSoldOutToBottom();
    var grid = document.getElementById('product-grid');
    if (grid) {
      _observer = new MutationObserver(function(mutations) {
        var added = mutations.some(function(m) { return m.addedNodes.length > 0; });
        if (added) sortSoldOutToBottom();
      });
      _observer.observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();